
    <mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
        <mat-card-header>
            <span mat-card-avatar>
            <mat-icon>account_circle</mat-icon>
            </span>
            <mat-card-title>Assign User</mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
    <mat-dialog-content>
        <table mat-table matSort (matSortChange)="sortChange($event)" [dataSource]="dataSource">
            <ng-container matColumnDef="username">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Username</th>
              <td mat-cell *matCellDef="let element">
                <mat-icon style="vertical-align: middle;" [color]="element.signalRConnected ? 'primary' : 'accent'" class="user-icon">account_circle</mat-icon><span style="font-size: 12px; padding-left:5px;"  class="user-name">{{element.username}}</span>
              </td>
            </ng-container>

            <ng-container style="display: none;" matColumnDef="firstname">
              <th style="display: none;" mat-header-cell *matHeaderCellDef mat-sort-header>Firstname</th>
              <td style="display: none;" mat-cell *matCellDef="let element">{{ element.firstname }}</td>
            </ng-container>

            <ng-container style="display: none;" matColumnDef="lastname">
              <th style="display: none;" mat-header-cell *matHeaderCellDef mat-sort-header>Lastname</th>
              <td style="display: none;" mat-cell *matCellDef="let element">{{ element.lastname }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
              <td style="font-size: 12px; padding: 10px;" mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>


            <ng-container matColumnDef="actions">
                <th class="action-column" mat-header-cell *matHeaderCellDef>Action</th>
                <td class="action-column" mat-cell *matCellDef="let element">
                    <button style="    font-size: 12px;
                    font-weight: 400;
                    margin-right: 5px;
                    scale: 0.9;
                    background: #bf1e2e;
                    color: white;
                    border-radius: 0px;
                    text-shadow: none;
                    box-shadow: none;
                    flex: 1 1 100%;
                    box-sizing: border-box;
                    max-width: 50%;
                    cursor: pointer;
                    transition: background-color 0.3s;
                    box-shadow: none !important;" mat-raised-button [disabled]="isLoading" (click)="assign(element)">
                        Assign
                      </button>
                </td>
              </ng-container>

            <tr mat-header-row *matHeaderRowDef="dataSourceConfig.columns"></tr>
            <tr mat-row *matRowDef="let row; columns: dataSourceConfig.columns"></tr>

        </table>
        <div class="card-spacer">
            <mat-paginator (page)="page($event)" [pageSizeOptions]="dataSourceConfig.pageSizeOptions"
              [hidePageSize]="isMobileMode"></mat-paginator>
          </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button style="  font-size: 10px;
    margin-right: 5px;
    scale: 1;
    background: #bf1e2e;
    color: white;
    border-radius: 0px;
    text-shadow: none;
    box-shadow: none;
    flex: 1 1 100%;
    box-sizing: border-box;
    max-width: 50px;
    cursor: pointer;
    transition: background-color 0.3s;
    box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>
  </mat-dialog-actions>
</mat-card>

